import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {api, apis, rd, sendGet} from "../../vars/rd";
import PageBack from "../components/buttons/page-back";
import {$shutils} from "../../libs/snnh/snnh";
import {preloaderHide, preloaderShow} from "../../libs/redux/actions/preloader";
import DaoChannel from "../../modules/dao/channel";
import ChannelItem from "../components/elements/channel.item";


class SearchResultChannel extends Component {
    is_loading = false;
    keydownHandler;
    scrollPosition = 0;
    scrollHandler;
    scrollRef;
    constructor(props) {
        super(props);

        this.keydownHandler = this.eventKeyDown.bind(this);
        this.scrollHandler = this.eventScroll.bind(this);

        const query = props.match.params.query;
        if(!query) {
            props.history.goBack();
            return;
        }

        this.state = {
            query,
            page: 0,
            page_count: 0,
            total: 0,
            searchQuery: '',
            items: []
        };
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    componentDidMount() {
        this.mounted = true;

        if(this.scrollRef) this.scrollRef.focus();

        document.addEventListener('keydown', this.keydownHandler);
        if(this.scrollRef) this.scrollRef.addEventListener('scroll', this.scrollHandler);

        // 데이터 로딩
        this.data(this.state.query, 1).then(() => {});
    }

    componentWillUnmount() {
        this.mounted = false;

        document.removeEventListener('keydown', this.keydownHandler);
        if(this.scrollRef) this.scrollRef.removeEventListener('scroll', this.scrollHandler);
        this.scrollRef = null;
    }


    /**
     * 키보드 다운 이벤트
     * @param e
     */
    eventKeyDown(e) {
        if (e.key === 'Enter' && document.activeElement.tagName === 'INPUT') {
            this.searchProcess();
        }
        // if (e.which === 13) this.searchProcess();
    }

    /**
     * 스크롤 이벤트
     * @param e
     */
    eventScroll(e) {
        try {
            const scroller = e.currentTarget;
            if(scroller) {
                const scrollHeight = scroller.scrollHeight;
                const height = scroller.offsetHeight;
                const top = scroller.scrollTop;
                if(top > this.scrollPosition) {
                    const gap = scrollHeight - (height + top);
                    if(gap < 30) this.next();
                }
                this.scrollPosition = top;
            }
        } catch (e) {}
    }

    /**
     * 채널데이터 다음 페이지 존재여부
     * @returns {boolean}
     */
    hasNext() {
        return this.state && ((this.state.total || 0) > (this.state.page_count || 0));
    }

    /**
     * 채널데이터 다음 인출
     * @returns
     */
    next() {
        if (this.hasNext() && !this.is_loading) {
            this.is_loading = true;
            const page = this.state.page + 1;
            this.data(this.state.query, page).then();
        }
    }

    async data(query, page) {
        try {
            if (!this.is_loading) {
            // if(this.state.page !== page) {
                this.dispatch(preloaderShow());

                const url = api(apis.channel_search, {
                    serviceid: rd.user.serviceid,
                    groupid: rd.user.groupid,
                    search_key: 'title',
                    search_val: query,
                    p: page
                });
                const json = await sendGet(url);

                if(this.mounted) {
                    const page_count = json.page_count;
                    const total = json.total;

                    this.dispatch(preloaderHide());
                    const items = [];
                    if (json.items.length) {
                        for (let i = 0; i < json.items.length; i++) {
                            const item_json = json.items[i];
                            const item = new DaoChannel(item_json);
                            items.push(item);
                        }
                    }
                    this.setState({items: [...this.state.items, ...items], page, page_count, total}, () => {
                        this.is_loading = false;
                    });
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    changeQuery(searchQuery) {
        this.setState({ searchQuery });
    }

    searchClear() {
        this.setState({searchQuery: ''})
    }

    searchProcess() {
        const query = this.state.searchQuery;
        if(!query) return;

        this.setState(
            {
                query,
                page: 0,
                page_count: 0,
                total: 0,
                searchQuery: '',
                items: []
            },
            async () => {
                await this.data(query, 1);
            }
        );
    }

    render() {
        return (
            <div className="search-wrap">
                <div className="search-box">
                    <h2>
                        <PageBack/>
                    </h2>
                    <div className="search-bar">
                        <div className="input-wrap w100">
                            <span className="sch-text">{this.state.query}</span>
                            <input className="input-w1" type="text"
                                   placeholder={`${$shutils.toPrice(this.state.total)}개의 검색결과`}
                                   value={this.state.searchQuery}
                                   onChange={e => this.changeQuery(e.target.value)}/>
                            {/*<span className="sch-result-text">8개의 검색 결과</span>*/}
                            {
                                this.state.searchQuery.length > 0 ?
                                    <span className="btn-sch2" onClick={() => this.searchClear()}>
                                        <img src="/images/icon-del2.png" alt="검색어 삭제"/>
                                    </span> : null
                            }

                            <span className="btn-sch" onClick={() => this.searchProcess()}>
                                <img src="/images/icon-sch2.png" alt="검색"/>
                            </span>
                        </div>
                    </div>
                </div>

                {
                    this.state.items.length > 0 ?
                        // 데이터 존재시
                        (
                            <div className="search-result" ref={el => {
                                this.scrollRef = el;
                            }}>
                                {
                                    this.state.items.map(
                                        /**
                                         * @param channel {DaoChannel}
                                         * @param index {number}
                                         * @returns {JSX.Element}
                                         */
                                        (channel, index) => {
                                            return <ChannelItem key={index} data={channel} index={index}/>
                                        }
                                    )
                                }
                            </div>
                        ) :
                        // 데이터 미존재시
                        (
                            <div className="search-result" ref={el => {
                                this.scrollRef = el;
                            }}>
                                <div className={'empty'}>검색된 데이터가 없습니다.</div>
                            </div>
                        )
                }
                <div id="sentinel"></div>
            </div>
        );
    }
}


export default connect()(withRouter(SearchResultChannel));


// WEBPACK FOOTER //
// ./src/pages/search/result.channel.jsx